
import { PaymentsTable } from "@/components/admin/PaymentsTable";
import { ScrollText } from "lucide-react";

interface TableSectionProps {
  payments: any[] | undefined;
  isLoading: boolean;
  gymId: string | null;
}

export const TableSection = ({ payments, isLoading, gymId }: TableSectionProps) => {
  const paymentsCount = payments?.length || 0;

  return (
    <div className="glass-card rounded-xl border border-primary/10 overflow-hidden">
      <div className="p-4 sm:p-6 border-b border-primary/10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <ScrollText className="h-5 w-5 text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-primary">Historial de pagos</h3>
          </div>
          
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-primary/5 text-primary/60 border border-primary/10">
            {paymentsCount} {paymentsCount === 1 ? 'registro' : 'registros'}
          </span>
        </div>
      </div>
      
      <div className="p-4 sm:p-6">
        <PaymentsTable 
          payments={payments || []} 
          isLoading={isLoading} 
          gymId={gymId}
        />
      </div>
    </div>
  );
};
